// src/app/(dashboard)/components/Navbar.tsx
"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { ThemeToggle } from "./ThemeToggle";
import { ApiStatusButton } from "./ApiStatusButton";

export function Navbar() {
  const pathname = usePathname();

  return (
    <header
      className={[
        "sticky top-0 z-30 h-14",
        "border-b border-slate-200 bg-white/95 backdrop-blur-sm",
        "dark:border-slate-800 dark:bg-slate-900/95",
        "flex items-center gap-4 px-6",
      ].join(" ")}
    >
      {/* Brand */}
      <Link
        href="/meter"
        className="flex items-center gap-2 font-bold leading-none shrink-0"
      >
        <BoltIcon />
        <span className="flex items-baseline gap-1">
          <span className="text-purple-600 dark:text-purple-400">PEA</span>
          <span className="text-slate-900 dark:text-slate-50">MDM-VIEWER</span>
        </span>
      </Link>

      {/* Divider */}
      <div className="h-5 w-px bg-slate-200 dark:bg-slate-700 shrink-0" />

      {/* Nav links */}
      <nav className="flex flex-1 items-center gap-1">
        <NavLink href="/meter" active={pathname.startsWith("/meter")}>
          <MeterIcon />
          รายการมิเตอร์
        </NavLink>
      </nav>

      {/* Right side */}
      <div className="flex items-center gap-2">
        <ApiStatusButton />
        <ThemeToggle />
      </div>
    </header>
  );
}

function NavLink({
  href,
  active,
  children,
}: {
  href: string;
  active: boolean;
  children: React.ReactNode;
}) {
  return (
    <Link
      href={href}
      className={[
        "flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-sm font-medium transition-colors",
        active
          ? "bg-purple-50 text-purple-700 dark:bg-purple-950 dark:text-purple-300"
          : "text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-800",
      ].join(" ")}
    >
      {children}
    </Link>
  );
}

function BoltIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="text-purple-600 dark:text-purple-400"
      aria-hidden="true"
    >
      <path d="M13 2 3 14h9l-1 8 10-12h-9l1-8z" />
    </svg>
  );
}

function MeterIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="2" y="3" width="20" height="14" rx="2" />
      <path d="M8 21h8M12 17v4" />
      <path d="M7 8h.01M12 8h.01M17 8h.01M7 12h10" />
    </svg>
  );
}
